var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-icon btn-circle btn-danger btn-scroll-to-top fade",class:{ show: _vm.appOptions.appBodyScrollTop },on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fa fa-angle-up"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }